(function () {
  function list(raw) {
    return (raw || '')
      .split(',')
      .map(function (value) {
        return value.trim().toLowerCase();
      })
      .filter(Boolean);
  }

  function parseConditions(raw) {
    return (raw || '')
      .split(';')
      .map(function (part) {
        var pair = part.split('=');
        if (pair.length < 2) return null;
        var key = pair[0].trim().toLowerCase();
        var values = pair
          .slice(1)
          .join('=')
          .split('|')
          .map(function (value) {
            return value.trim().toLowerCase();
          })
          .filter(Boolean);
        return key && values.length ? { key: key, values: values } : null;
      })
      .filter(Boolean);
  }

  function init(section) {
    if (!section || section.dataset.hmcReady === 'true') return;

    var form = section.querySelector('[data-hmc-form]');
    var questions = Array.prototype.slice.call(section.querySelectorAll('[data-hmc-question]'));
    if (!form || !questions.length) return;
    section.dataset.hmcReady = 'true';

    var steps = section.querySelectorAll('[data-hmc-step]');
    var gate = section.querySelector('[data-hmc-gate]');
    var result = section.querySelector('[data-hmc-result]');
    var outcomes = Array.prototype.slice.call(section.querySelectorAll('[data-hmc-outcome]'));
    var noMatch = section.querySelector('[data-hmc-no-match]');
    var answersList = section.querySelector('[data-hmc-answers]');
    var counter = section.querySelector('[data-hmc-counter]');
    var autoAdvance = section.dataset.autoAdvance === 'true';
    // Only a pointer advances on its own: arrow-keying through radios must not skip ahead.
    var pointerAt = 0;
    // A queued auto-advance. Next stays hidden while this is pending, otherwise it
    // appears the instant an answer is checked and vanishes 180ms later when the
    // quiz moves on, which reads as a flicker.
    var advanceTimer = null;
    var backButton = section.querySelector('[data-hmc-back]');
    var nextButton = section.querySelector('[data-hmc-next]');
    var commercialValues = list(section.dataset.commercialValues);
    var generatorValues = list(section.dataset.generatorValues);

    var current = 0;
    var gateOpen = false;
    var gateChoice = null; // 'generator' | 'outlet' once the buyer answers the generator check

    var money;
    try {
      money = new Intl.NumberFormat(section.dataset.locale || undefined, {
        style: 'currency',
        currency: section.dataset.currency || 'USD'
      });
    } catch (error) {
      money = { format: function (amount) { return '$' + amount.toFixed(2); } };
    }

    outcomes.forEach(function (outcome) {
      outcome.hmcConditions = parseConditions(outcome.dataset.conditions);
    });

    section.classList.add('hmc--js');
    if (autoAdvance) section.classList.add('hmc--auto');

    function clearAdvance() {
      if (advanceTimer === null) return;
      window.clearTimeout(advanceTimer);
      advanceTimer = null;
    }

    function checkedInput(question) {
      return question.querySelector('[data-hmc-input]:checked');
    }

    function answers() {
      var collected = {};
      questions.forEach(function (question) {
        var input = checkedInput(question);
        if (input) collected[question.dataset.key] = input.value.toLowerCase();
      });
      return collected;
    }

    function isCommercialAudience(collected) {
      return commercialValues.indexOf(collected.audience) !== -1;
    }

    function hasGenerator(collected) {
      return generatorValues.indexOf(collected.power) !== -1;
    }

    function needsGate(question) {
      if (!gate || question.dataset.key !== 'power') return false;
      var collected = answers();
      return isCommercialAudience(collected) && !hasGenerator(collected);
    }

    function branch(collected) {
      if (!isCommercialAudience(collected)) return 'residential';
      if (hasGenerator(collected) || gateChoice === 'generator') return 'commercial';
      return 'residential';
    }

    function matchFor(collected) {
      var best = null;
      var bestScore = -1;
      outcomes.forEach(function (outcome) {
        var conditions = outcome.hmcConditions;
        if (!conditions.length) return;
        var satisfied = conditions.every(function (condition) {
          return condition.values.indexOf(collected[condition.key]) !== -1;
        });
        if (satisfied && conditions.length > bestScore) {
          best = outcome;
          bestScore = conditions.length;
        }
      });
      return best;
    }

    function focusHeading(el) {
      if (!el) return;
      el.focus({ preventScroll: true });
      var top = section.getBoundingClientRect().top;
      if (top < 0) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function renderSteps(doneAll) {
      Array.prototype.forEach.call(steps, function (step, index) {
        step.classList.toggle('is-active', !doneAll && index === current);
        step.classList.toggle('is-done', doneAll || index < current);
        if (!doneAll && index === current) step.setAttribute('aria-current', 'step');
        else step.removeAttribute('aria-current');
      });
    }

    function renderCounter() {
      if (!counter) return;
      var label = counter.dataset.label || '';
      var total = counter.dataset.total || String(questions.length);
      counter.hidden = gateOpen;
      counter.textContent = label
        .split('[current]').join(String(current + 1))
        .split('[total]').join(total);
    }

    function render() {
      questions.forEach(function (question, index) {
        question.hidden = gateOpen || index !== current;
      });
      if (gate) gate.hidden = !gateOpen;
      renderSteps(false);
      renderCounter();

      backButton.hidden = current === 0 && !gateOpen;
      // Click-to-advance keeps Next in the DOM for keyboard use, but out of the way.
      nextButton.hidden =
        gateOpen || (autoAdvance && (advanceTimer !== null || !checkedInput(questions[current])));
      nextButton.disabled = !checkedInput(questions[current]);
      nextButton.textContent =
        current === questions.length - 1 ? nextButton.dataset.lastLabel : nextButton.dataset.label;
    }

    function fillPole(outcome, collected) {
      var template = null;
      Array.prototype.forEach.call(section.querySelectorAll('template[data-hmc-pole]'), function (candidate) {
        if (candidate.getAttribute('data-hmc-pole').toLowerCase() === collected.height) template = candidate;
      });

      Array.prototype.forEach.call(outcome.querySelectorAll('[data-hmc-machine]'), function (machine) {
        var poleRow = machine.querySelector('[data-hmc-pole-row]');
        var totalRow = machine.querySelector('[data-hmc-total-row]');
        var poleLink = machine.querySelector('[data-hmc-pole-link]');

        poleRow.hidden = !template;
        totalRow.hidden = !template;
        poleLink.hidden = !template;
        if (!template) return;

        // A pole kit on pre-order says so in its row, the same way the machine does.
        machine.querySelector('[data-hmc-pole-name]').textContent = template.dataset.preorderLabel
          ? template.dataset.name + ' (' + template.dataset.preorderLabel + ')'
          : template.dataset.name;
        machine.querySelector('[data-hmc-pole-price]').textContent = template.dataset.priceLabel;
        poleLink.href = template.dataset.url;

        var cents = parseInt(machine.dataset.price, 10) + parseInt(template.dataset.price, 10);
        machine.querySelector('[data-hmc-total]').textContent = money.format(cents / 100);
      });
    }

    function renderAnswers() {
      if (!answersList) return;
      answersList.innerHTML = '';
      questions.forEach(function (question) {
        var input = checkedInput(question);
        if (!input) return;
        var label = section.querySelector('label[for="' + input.id + '"] .hmc__option-title');
        var item = document.createElement('li');
        item.textContent = label ? label.textContent : input.value;
        answersList.appendChild(item);
      });

      var gateButton = gateChoice && gate && gate.querySelector('[data-hmc-gate-choice="' + gateChoice + '"]');
      if (gateButton) {
        var gateItem = document.createElement('li');
        gateItem.textContent = gateButton.textContent;
        answersList.appendChild(gateItem);
      }
    }

    function showResult() {
      var collected = answers();
      collected.branch = branch(collected);
      var match = matchFor(collected);

      questions.forEach(function (question) {
        question.hidden = true;
      });
      if (gate) gate.hidden = true;
      outcomes.forEach(function (outcome) {
        outcome.hidden = outcome !== match;
      });
      if (match) fillPole(match, collected);
      if (noMatch) noMatch.hidden = !!match;

      renderAnswers();
      renderSteps(true);
      section.classList.add('hmc--result');
      if (counter) counter.hidden = true;
      result.hidden = false;
      focusHeading(result.querySelector('.hmc__result-title'));

      section.dispatchEvent(
        new CustomEvent('hmc:result', {
          bubbles: true,
          detail: { answers: collected, matched: !!match }
        })
      );
    }

    function goNext() {
      var question = questions[current];
      if (!checkedInput(question)) return;

      if (!gateOpen && gateChoice === null && needsGate(question)) {
        gateOpen = true;
        render();
        focusHeading(gate.querySelector('.hmc__gate-title'));
        return;
      }

      gateOpen = false;
      if (current < questions.length - 1) {
        current += 1;
        render();
        focusHeading(questions[current].querySelector('.hmc__legend'));
        return;
      }
      showResult();
    }

    function goBack() {
      clearAdvance();
      if (gateOpen) {
        gateOpen = false;
      } else if (current > 0) {
        current -= 1;
      }
      render();
      focusHeading(questions[current].querySelector('.hmc__legend'));
    }

    function reset() {
      clearAdvance();
      Array.prototype.forEach.call(form.querySelectorAll('[data-hmc-input]'), function (input) {
        input.checked = false;
      });
      current = 0;
      gateOpen = false;
      gateChoice = null;
      result.hidden = true;
      section.classList.remove('hmc--result');
      render();
      focusHeading(questions[0].querySelector('.hmc__legend'));
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      goNext();
    });

    form.addEventListener('pointerdown', function () {
      pointerAt = Date.now();
    });

    form.addEventListener('change', function (event) {
      if (!event.target.matches('[data-hmc-input]')) return;
      var question = event.target.closest('[data-hmc-question]');
      if (question && (question.dataset.key === 'audience' || question.dataset.key === 'power')) gateChoice = null;
      clearAdvance();
      if (autoAdvance && Date.now() - pointerAt < 700) {
        var picked = event.target;
        // Queued before render() so render() knows Next is on its way out.
        advanceTimer = window.setTimeout(function () {
          advanceTimer = null;
          // Ignore a stale timer if the answer changed again, or the quiz moved on.
          if (!picked.checked || gateOpen) return render();
          if (questions[current] !== picked.closest('[data-hmc-question]')) return render();
          goNext();
        }, 180);
      }
      render();
    });

    section.addEventListener('click', function (event) {
      var choice = event.target.closest('[data-hmc-gate-choice]');
      if (choice) {
        gateChoice = choice.getAttribute('data-hmc-gate-choice');
        goNext();
        return;
      }

      var material = event.target.closest('[data-hmc-material]');
      if (material) {
        var outcome = material.closest('[data-hmc-outcome]');
        var wanted = material.getAttribute('data-hmc-material');
        Array.prototype.forEach.call(outcome.querySelectorAll('[data-hmc-machine]'), function (machine) {
          machine.hidden = machine.getAttribute('data-hmc-machine') !== wanted;
        });
        var active = outcome.querySelector('[data-hmc-machine="' + wanted + '"] [data-hmc-material="' + wanted + '"]');
        if (active) active.focus();
        return;
      }

      if (event.target.closest('[data-hmc-back]')) goBack();
      else if (event.target.closest('[data-hmc-restart]')) reset();
    });

    render();
  }

  // Hours default to the header contact widget's "Hours of operation", so they live in one place.
  function fillHours() {
    var source = document.querySelector('.contact__support--info .cs_desc .cs_circle.online-content');
    var text = source ? source.textContent.trim() : '';
    if (!text) return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-hmc-hours]'), function (el) {
      el.textContent = text;
      el.hidden = false;
    });
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-hmc]'), init);
    fillHours();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target.querySelector('[data-hmc]'));
    fillHours();
  });

  // Which step the shopper was on when they left the quiz for a human.
  function stepOf(el) {
    var section = el.closest('[data-hmc]');
    if (!section) return 'unknown';
    if (section.classList.contains('hmc--result')) return 'result';
    var steps = section.querySelectorAll('[data-hmc-step]');
    for (var i = 0; i < steps.length; i++) {
      if (steps[i].classList.contains('is-active')) return String(i + 1);
    }
    return 'unknown';
  }

  function track(name, step) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, hmc_step: step });
  }

  // Calendly's widget is only fetched when someone asks to book.
  var calendlyLoading = null;
  function loadCalendly() {
    if (window.Calendly) return Promise.resolve();
    if (calendlyLoading) return calendlyLoading;
    calendlyLoading = new Promise(function (resolve, reject) {
      var css = document.createElement('link');
      css.rel = 'stylesheet';
      css.href = 'https://assets.calendly.com/assets/external/widget.css';
      document.head.appendChild(css);
      var js = document.createElement('script');
      js.src = 'https://assets.calendly.com/assets/external/widget.js';
      js.async = true;
      js.onload = function () { resolve(); };
      js.onerror = function () { calendlyLoading = null; reject(); };
      document.head.appendChild(js);
    });
    return calendlyLoading;
  }

  var bookedFromStep = null;

  document.addEventListener('click', function (event) {
    var call = event.target.closest('[data-hmc-expert-call]');
    if (call) {
      track('hmc_expert_call', stepOf(call));
      return;
    }

    var book = event.target.closest('[data-hmc-calendly]');
    if (!book) return;
    event.preventDefault();
    var step = stepOf(book);
    bookedFromStep = step;
    track('hmc_expert_book', step);
    loadCalendly().then(function () {
      window.Calendly.initPopupWidget({
        url: book.getAttribute('data-hmc-calendly'),
        utm: { utmSource: 'website', utmMedium: 'help-me-choose', utmContent: 'step-' + step },
      });
    }).catch(function () {
      // Widget blocked or down: fall back to Calendly's own page.
      if (!window.open(book.href, '_blank', 'noopener')) window.location.href = book.href;
    });
  });

  // An actual booking, not just the popup opening.
  window.addEventListener('message', function (event) {
    if (event.origin !== 'https://calendly.com' || !event.data || event.data.event !== 'calendly.event_scheduled') return;
    if (bookedFromStep === null) return;
    track('hmc_expert_booked', bookedFromStep);
    bookedFromStep = null;
  });
})();
